































import { Component, Mixins, Prop } from "vue-property-decorator";
import mixins from "../mixins";
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: "#576B95" }) fill;
  @Prop({ default: 26 }) size;
}
